import { render } from "./_SocialMedia.vue?vue&type=template&id=ee84e83a&scoped=true"
import script from "./_SocialMedia.vue?vue&type=script&lang=js"
export * from "./_SocialMedia.vue?vue&type=script&lang=js"

import "./_SocialMedia.vue?vue&type=style&index=0&id=ee84e83a&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee84e83a"]])

export default __exports__